import { BLOCK_TYPES } from "../../common";
import { isValidCallbackDragArrangeList } from "../DragArrangeList";

const { COMPARE_ARRANGE_LIST_BLOCK } = BLOCK_TYPES;

const isValidCallback = (props: any) =>
    isValidCallbackDragArrangeList({
        ...props,
        blockType: COMPARE_ARRANGE_LIST_BLOCK,
    });

export default isValidCallback;
